var exports = {
  "kL": "xa15a2ab7--d416b3--container",
  "iU": "xa15a2ab7--d416b3--message",
};

module.exports = exports;
